interface ArchiveSealProps {
  size?: 'small' | 'medium' | 'large';
  active?: boolean;
  label?: string;
}

export function ArchiveSeal({
  size = 'medium',
  active = false,
  label = 'Sello de la Biblioteca',
}: ArchiveSealProps) {
  return (
    <div
      className={`archive-seal archive-seal--${size}${active ? ' is-active' : ''}`}
      role="img"
      aria-label={label}
    >
      <span className="seal-ring seal-ring--outer" />
      <span className="seal-ring seal-ring--middle" />
      <span className="seal-cross" />
      <span className="seal-orbit seal-orbit--one" />
      <span className="seal-orbit seal-orbit--two" />
      <span className="seal-core" />
    </div>
  );
}
